import { mapState } from 'vuex';
import ApiService from '../../../services/apiService';
import { isNumericValue } from '../../../utils/vuex';
import get from 'lodash/get';
import set from 'lodash/set';
import pullAt from 'lodash/pullAt';
import cloneDeep from 'lodash/cloneDeep';
import isEqual from 'lodash/isEqual';
import isArray from 'lodash/isArray';
import { nanoid } from 'nanoid';
const regexImageExt = '(jp(e?)g|png|gif)';
const regexAudioExt = '(o(pus|g([gax]{1}))|spx|webm|mp3|(fl|a)ac|wav(e?))';
export default {
  name: 'ViewISWarnappAdmin',
  data: function () {
    return {
      treeLoading: false,
      selected: null,
      originalTwin: null,
      twinDataStates: [],
      originalTwinDataStates: [],
      search: null,
      // the "v-model"-bind for the state-selection
      // reset to empty array on each intersection, as we do not want to save any of it
      // just a quick workaround to make sure the form is always "clean"
      pickedKeys: {},
      selectStatePrompt: false,
      selectedState: null,
      selectedStateKey: null
    };
  },
  computed: {
    ...mapState('app', ['inpOutlined', 'inpFilled', 'image', 'color', 'UiTheme']),
    attachmentButtons() {
      return [{
        title: this.$i18n_t('DigitalTwin.DigitalTwin.attachmentButtonAdd'),
        icon: 'fal fa-plus',
        action: 'addAttachment'
      }];
    },
    uploadAccept() {
      let acceptedTypes = [];
      if (this.warnAppAttachments.findIndex(a => new RegExp(`^warnapp_logo\\.${regexImageExt}$`, 'i').test(a.name)) < 0) {
        acceptedTypes.push('image/*');
      }
      if (this.warnAppAttachments.findIndex(a => new RegExp(`^warnapp_alarm\\.${regexAudioExt}$`, 'i').test(a.name)) < 0) {
        acceptedTypes.push('audio/*');
      }
      return acceptedTypes.join(', ');
    },
    warnAppValidGauge() {
      return (this.twinDataStates || []).find(state => {
        return state.key.toLowerCase() === 'warnapp_gauge';
      });
    },
    warnAppValidUpperLimit() {
      return (this.twinDataStates || []).find(state => {
        return state.key.toLowerCase() === 'warnapp_alarm_high';
      });
    },
    warnAppValidLowerLimit() {
      return (this.twinDataStates || []).find(state => {
        return state.key.toLowerCase() === 'warnapp_alarm_low';
      });
    },
    warnAppStates() {
      return (this.twinDataStates || []).filter(state => {
        return state.key !== get(this.warnAppValidGauge, 'key') && state.key !== get(this.warnAppValidUpperLimit, 'key') && state.key !== get(this.warnAppValidLowerLimit, 'key') && get(state, 'properties.valueType') === 'number';
      });
    },
    warnStateChanged() {
      if (get(this.warnAppValidUpperLimit, 'value.value') !== undefined) {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.warnAppValidUpperLimit.value.value = parseFloat(this.warnAppValidUpperLimit.value.value);
      }
      if (get(this.warnAppValidLowerLimit, 'value.value') !== undefined) {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.warnAppValidLowerLimit.value.value = parseFloat(this.warnAppValidLowerLimit.value.value);
      }
      return !isEqual(this.twinDataStates, this.originalTwinDataStates) || !isEqual(this.selected, this.originalTwin);
    },
    warnAppAttachments() {
      return get(this.selected, 'data.attachments', []).filter(a => {
        return new RegExp(`^warnapp_logo\\.${regexImageExt}$`, 'i').test(a.name) || new RegExp(`^warnapp_alarm\\.${regexAudioExt}$`, 'i').test(a.name);
      });
    }
  },
  methods: {
    updateWarnAppValidGauge(updatedModel) {
      this.warnAppValidGauge = cloneDeep(updatedModel);
    },
    get,
    customFileSelectionHandler(files) {
      const regExpHasImageExt = new RegExp(`\\.${regexImageExt}$`, 'i');
      const regExpHasAudioExt = new RegExp(`\\.${regexAudioExt}$`, 'i');
      let mappedFiles = cloneDeep(files.filter(file => {
        return regExpHasImageExt.test(file.name) || regExpHasAudioExt.test(file.name);
      }));
      // only keep the first image or audio in the list, throw away the rest
      for (let i = 0; i < mappedFiles.length - 1; i++) {
        const currentFile = mappedFiles[i];
        for (let j = i + 1; j < mappedFiles.length; j++) {
          if (j !== i) {
            const followFile = mappedFiles[j];
            if (regExpHasImageExt.test(currentFile.name) && regExpHasImageExt.test(followFile.name)) {
              pullAt(mappedFiles, [j]);
              j--;
            } else if (regExpHasAudioExt.test(currentFile.name) && regExpHasAudioExt.test(followFile.name)) {
              pullAt(mappedFiles, [j]);
              j--;
            }
          }
        }
      }
      this.$refs.fileAttachments.queue = mappedFiles.map(file => {
        let newName = file.name;
        if (regExpHasImageExt.test(file.name)) {
          const rawFileName = new RegExp(`^(.+?)\\.${regexImageExt}$`, 'i').exec(file.name);
          newName = `warnapp_logo.${rawFileName[2].toLowerCase()}`;
        } else if (regExpHasAudioExt.test(file.name)) {
          const rawFileName = new RegExp(`^(.+?)\\.${regexAudioExt}$`, 'i').exec(file.name);
          newName = `warnapp_alarm.${rawFileName[2].toLowerCase()}`;
        }
        return new File([file], newName, {
          type: file.type,
          lastModified: file.lastModified
        });
      });
      this.$refs.fileAttachments.addFilesToUploads();
    },
    attachmentsUpdated(data) {
      this.selected.data.attachments = data;
      this.$store.state.app.loading = true;
      return ApiService.digitalTwinUpdate(this, this.selected).then(result => {
        this.selected = result;
        this.$snack(this.$i18n_t('Common.digitalTwins.twinUpdated'), 'success');
        this.$store.state.app.dtwins = {};
        return this.selected;
      }).catch(error => {
        console.error(error);
        if (error.response && this.$i18n_t(`Error.${error.response.data.message}`)) {
          this.$snack(this.$i18n_t(`Error.${error.response.data.message}`), 'error');
        } else {
          this.$snack(this.$i18n_t('Common.digitalTwins.twinUpdatedFail'), 'error');
        }
      }).finally(() => {
        this.$store.state.app.loading = false;
      });
    },
    warnAppTypePicked(state, type) {
      this.selectedState = state;
      this.selectedStateKey = type;
      this.selectStatePrompt = true;
    },
    createAlarmState(type) {
      let stateObject = {
        dtwinId: this.selected.id,
        key: `warnapp_alarm_${type}`,
        value: {
          value: type === 'low' ? 0 : 100
        },
        properties: {
          title: `Warnapp Alarm ${type.charAt(0).toUpperCase() + type.slice(1)}`,
          valueType: 'number',
          binding: {
            type: 'none'
          },
          visual: {
            type: 'hidden',
            options: {}
          }
        }
      };
      this.twinDataStates.push(stateObject);
    },
    statePickConfirmed() {
      if (this.selectedStateKey === 'warnapp_gauge') {
        // add a tag to identify this twin as having a valid warnapp state
        // (for the viewer tree selection)

        // make sure the tags are actually an array
        if (!isArray(get(this.selected, 'data.tags'))) {
          this.selected.data.tags = [];
        }
        const newTags = this.selected.data.tags.filter(t => t.toLowerCase() !== 'warnapp-sensor').concat(['warnapp-sensor']);
        this.selected.data.tags = newTags;
        if (!get(this.selectedState, 'properties.visual.options')) {
          set(this.selectedState, 'properties.visual.options', {});
        }
        // to display any gauge visualisation, make sure there is a non-null value
        if (!isNumericValue(this.selectedState.value.value)) {
          this.selectedState.value.value = 0;
          this.selectedState.value.hasChanged = true;
        }
        if (this.selectedState.properties.visual.type !== 'gauge') {
          this.selectedState.properties.visual.type = 'gauge';
          this.selectedState.properties.visual.options.min = '250';
          this.selectedState.properties.visual.options.max = '750';
          this.selectedState.properties.visual.options.thresholds = '250, 500';
          this.selectedState.properties.visual.options.reverse = false;
          // darkgreen, yellow, red
          this.selectedState.properties.visual.options.thresColors = ['#388e3c', '#fec60a', '#ff1744'];
        }
      }
      this.selectedState.key = this.selectedStateKey;
    },
    warnAppTypesForState() {
      let types = [];
      if (!this.warnAppValidGauge) {
        types.push({
          text: 'WARN STATE',
          value: 'warnapp_gauge'
        });
      }
      if (!this.warnAppValidUpperLimit) {
        types.push({
          text: 'ALARM HIGH',
          value: 'warnapp_alarm_high'
        });
      }
      if (!this.warnAppValidLowerLimit) {
        types.push({
          text: 'ALARM LOW',
          value: 'warnapp_alarm_low'
        });
      }
      return types;
    },
    loadedInitialDtwins(dtwins) {
      if (dtwins && dtwins.length > 0) {
        this.selected = this.selected || dtwins[0];
        this.loadDigitalTwinStates(this.selected.id);
      }
    },
    loadDigitalTwinStates(dtwinId) {
      this.originalTwin = cloneDeep(this.selected);
      this.twinDataStates = [];
      return ApiService.digitalTwinFetchStates(this, dtwinId).then(twinDataStates => {
        this.twinDataStates = twinDataStates;
        this.originalTwinDataStates = cloneDeep(this.twinDataStates);
      });
    },
    resetGaugeState() {
      this.twinDataStates.forEach(state => {
        if (this.warnAppValidGauge && this.warnAppValidGauge.id === state.id) {
          state.key = `${state.key}_${nanoid()}`;
        }
      });
      // also remove the warnapp-sensor tag
      if (!isArray(get(this.selected, 'data.tags'))) {
        this.selected.data.tags = [];
      }
      const newTags = this.selected.data.tags.filter(t => t.toLowerCase() !== 'warnapp-sensor');
      this.selected.data.tags = newTags;
    },
    saveStates() {
      let promises = [ApiService.digitalTwinUpdate(this, this.selected)];
      if (this.warnAppValidGauge) {
        promises.push(ApiService.digitalTwinUpdateState(this, this.warnAppValidGauge));
      }
      if (this.warnAppValidUpperLimit) {
        if (get(this.warnAppValidUpperLimit, 'value.value') !== get(this.originalTwinDataStates.find(s => s.key === this.warnAppValidUpperLimit.key), 'value.value')) {
          this.warnAppValidUpperLimit.value.hasChanged = true;
          this.warnAppValidUpperLimit.value.skipTransformer = true;
        }
        if (this.warnAppValidUpperLimit.id) {
          promises.push(ApiService.digitalTwinUpdateState(this, this.warnAppValidUpperLimit));
        } else {
          promises.push(ApiService.digitalTwinCreateState(this, this.warnAppValidUpperLimit).then(state => {
            this.warnAppValidUpperLimit.id = state.id;
          }));
        }
      }
      if (this.warnAppValidLowerLimit) {
        if (get(this.warnAppValidLowerLimit, 'value.value') !== get(this.originalTwinDataStates.find(s => s.key === this.warnAppValidLowerLimit.key), 'value.value')) {
          this.warnAppValidLowerLimit.value.hasChanged = true;
          this.warnAppValidLowerLimit.value.skipTransformer = true;
        }
        if (this.warnAppValidLowerLimit.id) {
          promises.push(ApiService.digitalTwinUpdateState(this, this.warnAppValidLowerLimit));
        } else {
          promises.push(ApiService.digitalTwinCreateState(this, this.warnAppValidLowerLimit).then(state => {
            this.warnAppValidLowerLimit.id = state.id;
          }));
        }
      }
      this.$store.state.app.loading = true;
      Promise.all(promises).then(() => {
        this.$snack(this.$i18n_t('Common.digitalTwins.twinUpdated'), 'success');
        this.$store.state.app.dtwins = {};
        this.originalTwinDataStates = cloneDeep(this.twinDataStates);
        this.originalTwin = cloneDeep(this.selected);
        return this.selected;
      }).catch(error => {
        console.error(error);
        if (error.response && this.$i18n_t(`Error.${error.response.data.message}`)) {
          this.$snack(this.$i18n_t(`Error.${error.response.data.message}`), 'error');
        } else {
          this.$snack(this.$i18n_t('Common.digitalTwins.twinUpdatedFail'), 'error');
        }
      }).finally(() => {
        this.$store.state.app.loading = false;
      });
    }
  }
};